import { render } from "./NavMenuMobile.vue?vue&type=template&id=2895d136&scoped=true&ts=true"
import script from "./NavMenuMobile.vue?vue&type=script&lang=ts"
export * from "./NavMenuMobile.vue?vue&type=script&lang=ts"

import "./NavMenuMobile.vue?vue&type=style&index=0&id=2895d136&lang=scss&scoped=true"
import "./NavMenuMobile.vue?vue&type=style&index=1&id=2895d136&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2895d136"]])

export default __exports__